import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../../environments/environment';
import {
  CreateWhitelistAddressRequest,
  CreateWhitelistAddressResponse,
} from '../models/whitelist-address.model';

/**
 * All HTTP calls in this service return the standard
 * `ApiResponse<T>` envelope. The `apiResponseInterceptor` surfaces
 * `message` as a success toast automatically.
 */
@Injectable({
  providedIn: 'root',
})
export class WhitelistAddressService {
  private readonly baseUrl = `${environment.assetManagementApiUrl}/api/v1/network`;

  constructor(private http: HttpClient) {}

  createWhitelistAddress(
    request: CreateWhitelistAddressRequest
  ): Observable<CreateWhitelistAddressResponse> {
    return this.http.post<CreateWhitelistAddressResponse>(
      `${this.baseUrl}/whitelist-addresses`,
      request
    );
  }

  enableWhitelistAddress(
    addressWhitelistId: string
  ): Observable<CreateWhitelistAddressResponse> {
    return this.http.post<CreateWhitelistAddressResponse>(
      `${this.baseUrl}/whitelist-addresses/${addressWhitelistId}/enable`,
      {}
    );
  }

  disableWhitelistAddress(
    addressWhitelistId: string
  ): Observable<CreateWhitelistAddressResponse> {
    return this.http.post<CreateWhitelistAddressResponse>(
      `${this.baseUrl}/whitelist-addresses/${addressWhitelistId}/disable`,
      {}
    );
  }

  deleteWhitelistAddress(
    addressWhitelistId: string
  ): Observable<CreateWhitelistAddressResponse> {
    return this.http.delete<CreateWhitelistAddressResponse>(
      `${this.baseUrl}/whitelist-addresses/${addressWhitelistId}`
    );
  }
}
